import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemMailSendRoute: InvariantJiraRoute = {
	name: 'global-settings-system-mail-send',
	path: '/secure/admin/SendBulkMail!default.jspa',
};
